import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import { Grid, LibraryAddIcon, MouseOverPopover, Tabs, TemplatesTemplateLanguage, arrLanguages, TemplatesTemplateInfo, Dialog, DialogTemplateLanguageInfo, DialogTemplateAddLanguage, DialogTemplateEditType, DialogTemplateEditTags, translate, convertToRaw, FileUpload, Alert, Button, EditorState, ContentState, htmlToDraft, draftToHtml } from "../../../../";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import { Prompt } from "react-router-dom";
import { Typography, Tooltip } from "@material-ui/core";
import { Link } from "react-router-dom";
var TemplatesTemplateSingle = forwardRef(function (props, ref) {
  // console.log("props templates", props);
  var childRef = useRef();

  var _useState = useState("es"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      alert = _useState4[0],
      setAlert = _useState4[1];

  var _useState5 = useState({
    open: false
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      alertS3 = _useState6[0],
      setAlertS3 = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openHandleEditType = _useState8[0],
      setOpenHandleEditType = _useState8[1]; // const [openHandleEditTags, setOpenHandleEditTags] = useState(false);


  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openHandleAddLanguage = _useState10[0],
      setOpenHandleAddLanguage = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openHandleDeleteLanguage = _useState12[0],
      setOpenHandleDeleteLanguage = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      openHandleEditLanguage = _useState14[0],
      setOpenHandleEditLanguage = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      openHandleRestartTemplate = _useState16[0],
      setOpenHandleRestartTemplate = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openHandleChangeStatusTemplate = _useState18[0],
      setOpenHandleChangeStatusTemplate = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      openHandleEditTemplate = _useState20[0],
      setOpenHandleEditTemplate = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      openHandleDeleteTemplate = _useState22[0],
      setOpenHandleDeleteTemplate = _useState22[1];

  var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      languageToDelete = _useState24[0],
      setLanguageToDelete = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      languageToEdit = _useState26[0],
      setLanguageToEdit = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      statusTemplateToChange = _useState28[0],
      setStatusTemplateToChange = _useState28[1];

  useImperativeHandle(ref, function () {
    return {
      handleFromParent: function handleFromParent(method, value) {
        // console.log("method", method);
        if (method === "open_dialog_edit_task") {
          childRef.current.openDialogEditTask(value.task);
        } else if (method === "handle_add_language") {
          handleAddLanguage(value.values, value.language);
        }
      }
    };
  });
  var types = [{
    label: "Event",
    value: "event"
  }, {
    label: "Academy",
    value: "academy"
  }, {
    label: "Campus",
    value: "campus"
  }]; // HANDLE BEST PRACTICE

  var handleBestPracticeTemplate = function handleBestPracticeTemplate() {
    var isBestPractice = props.isBestPractice;
    props.handleBestPracticeTemplate(!isBestPractice);
  }; // HANDLE OPEN S3


  var handleCloseAlertS3 = function handleCloseAlertS3() {
    setAlertS3({
      open: false
    });
  }; // HANDLE ALERT S3


  var handleAlertS3 = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variant, values) {
      var clipboard;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = variant;
              _context.next = _context.t0 === "success" ? 3 : _context.t0 === "error" ? 9 : 11;
              break;

            case 3:
              // console.log("values success s3 upload", values);
              navigator.clipboard.writeText(values.publicUrl);
              _context.next = 6;
              return navigator.clipboard.readText();

            case 6:
              clipboard = _context.sent;
              setAlertS3({
                open: true,
                title: "Image uploaded",
                status: "success",
                text: clipboard ? /*#__PURE__*/React.createElement(Typography, {
                  variant: "body1"
                }, "URL coppied to clipboard") : [/*#__PURE__*/React.createElement(Typography, {
                  variant: "body1"
                }, "This is the url"), /*#__PURE__*/React.createElement(Typography, {
                  variant: "body2"
                }, values.publicUrl)],
                submit: "Close",
                onSubmit: handleCloseAlertS3,
                onClose: handleCloseAlertS3
              });
              return _context.abrupt("break", 12);

            case 9:
              // console.log("values error s3 upload", values);
              setAlertS3({
                open: true,
                title: "Image not uploaded",
                status: "error",
                text: "Take values",
                submit: "Close",
                onSubmit: handleCloseAlertS3,
                onClose: handleCloseAlertS3
              });
              return _context.abrupt("break", 12);

            case 11:
              return _context.abrupt("break", 12);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAlertS3(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // HANDLE ADD LANGUAGE


  var handleAddLanguage = function handleAddLanguage(values, language) {
    // console.log("HandleAddLangu", language);
    var languageDefault = _objectSpread(_objectSpread({}, language), {}, {
      status: "draft",
      reviewed: false
    }); // console.log("language default", languageDefault);


    Promise.all(Object.keys(values).filter(function (value) {
      // console.log("values handle add language filter", value);
      return values[value] === true;
    }).map(function (value) {
      // console.log("values handle add language value", value);
      // console.log("language", languageDefault);
      var phases = _toConsumableArray(languageDefault.phases);

      return Promise.all(phases.map(function (phase) {
        var extraFields = phase.extraFields;
        return Promise.all(extraFields.map(function (extraField) {
          var options = extraField.options;
          return Promise.all(options.map(function (option) {
            return translate(option.name, "es", value).then(function (optionTranslated) {
              return _objectSpread(_objectSpread({}, option), {}, {
                name: optionTranslated
              });
            });
          })).then(function (optionsTranslated) {
            return translate(extraField.name, "es", value).then(function (extraFieldNameTranslated) {
              return _objectSpread(_objectSpread({}, extraField), {}, {
                name: extraFieldNameTranslated,
                options: optionsTranslated
              });
            });
          });
        })).then(function (extraFieldsTranslated) {
          var editorStateItem = phase.details ? convertToRaw(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(phase.details).contentBlocks, htmlToDraft(phase.details).entityMap)).getCurrentContent()) : convertToRaw(EditorState.createEmpty().getCurrentContent());
          return Promise.all(editorStateItem.blocks.map(function (block) {
            if (block.text !== "") return translate(block.text, "es", value).then(function (text_translated) {
              return _objectSpread(_objectSpread({}, block), {}, {
                text: text_translated
              });
            });else {
              return _objectSpread({}, block);
            }
          })).then(function (blocksTranslated) {
            var editorStateItemTranslated = _objectSpread(_objectSpread({}, editorStateItem), {}, {
              blocks: blocksTranslated
            });

            if (phase.name !== "PLAN" && phase.name !== "DO & CHECK" && phase.name !== "CLOSE") {
              return translate(phase.name, "es", value).then(function (phaseNameTranslated) {
                return _objectSpread(_objectSpread({}, phase), {}, {
                  name: phaseNameTranslated,
                  details: draftToHtml(editorStateItemTranslated),
                  extraFields: extraFieldsTranslated
                });
              });
            } else {
              return _objectSpread(_objectSpread({}, phase), {}, {
                details: draftToHtml(editorStateItemTranslated),
                extraFields: extraFieldsTranslated
              });
            }
          });
        });
      })).then(function (phasesTranslated) {
        return Promise.all(languageDefault.tags.map(function (tag) {
          return translate(tag, "es", value).then(function (tagTranslated) {
            return tagTranslated;
          });
        })).then(function (tagsTranslated) {
          var editorStateDetails = languageDefault.details ? convertToRaw(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(languageDefault.details).contentBlocks, htmlToDraft(languageDefault.details).entityMap)).getCurrentContent()) : convertToRaw(EditorState.createEmpty().getCurrentContent()); // const editorStateDetails = languageDefault.detailsEditorStateSaved
          // const editorStateDetails = languageDefault.details
          //   ? convertToRaw(languageDefault.details.getCurrentContent())
          //   : convertToRaw(EditorState.createEmpty().getCurrentContent());

          return Promise.all(editorStateDetails.blocks.map(function (block) {
            if (block.text !== "") return translate(block.text, "es", value).then(function (text_translated) {
              return _objectSpread(_objectSpread({}, block), {}, {
                text: text_translated
              });
            });else {
              return _objectSpread({}, block);
            }
          })).then(function (detailsTranslated) {
            return translate(languageDefault.name, "es", value).then(function (nameTranslated) {
              return translate(languageDefault.description, "es", value).then(function (descriptionTranslated) {
                editorStateDetails.blocks = detailsTranslated;
                return _objectSpread(_objectSpread({}, languageDefault), {}, {
                  name: nameTranslated,
                  lang: value,
                  code: value,
                  description: descriptionTranslated,
                  phases: phasesTranslated,
                  tags: tagsTranslated,
                  details: draftToHtml(editorStateDetails) // detailsEditorState: EditorState.createWithContent(
                  //   ContentState.createFromBlockArray(
                  //     htmlToDraft(detailsTranslated).contentBlocks,
                  //     htmlToDraft(detailsTranslated).entityMap
                  //   )
                  // )

                });
              });
            });
          });
        });
      });
    })).then(function (x) {
      // console.log("final array", x);
      var languages = {};
      x.forEach(function (language) {
        languages[language.lang] = _objectSpread({}, language);
        delete languages[language.lang].lang;
      });
      props.handleAddLanguage(languages);
    });
  }; // MODAL EDIT TYPE


  var handleModalEditType = function handleModalEditType() {
    // console.log("handle button Modal edit type clicked");
    setOpenHandleEditType(!openHandleEditType);
  }; // MODAL EDIT Tags
  // const handleModalEditTags = () => {
  // console.log("handle button Modal edit tags clicked");
  //   setOpenHandleEditTags(!openHandleEditTags);
  // };
  // MODAL ADD LANGUAGE


  var handleModalAddLanguage = function handleModalAddLanguage() {
    // console.log("handle button Modal language clicked");
    setOpenHandleAddLanguage(!openHandleAddLanguage);
  }; // MODAL DELETE LANGUAGE


  var handleModalDeleteLanguage = function handleModalDeleteLanguage(language) {
    // console.log("handle delete language clicked", language);
    // Close modal
    if (openHandleDeleteLanguage) {
      setLanguageToDelete(null);
    } // Open modal
    else {
        setLanguageToDelete(language);
      }

    setOpenHandleDeleteLanguage(!openHandleDeleteLanguage);
  }; // MODAL EDIT LANGUAGE


  var handleModalEditLanguage = function handleModalEditLanguage(language) {
    // console.log("handle edit language clicked", language);
    // Close modal
    if (openHandleEditLanguage) {
      setLanguageToEdit(null);
    } // Open modal
    else {
        setLanguageToEdit(language);
      }

    setOpenHandleEditLanguage(!openHandleEditLanguage);
  }; // MODAL RESTART TEMPLATE


  var handleModalRestartTemplate = function handleModalRestartTemplate() {
    // console.log("handle restart template clicked");
    setOpenHandleRestartTemplate(!openHandleRestartTemplate);
  }; // MODAL CHANGE STATUS TEMPLATE


  var handleModalChangeStatusTemplate = function handleModalChangeStatusTemplate(prevStatus) {
    // console.log("handle change status template clicked", prevStatus);
    var status = "";

    switch (prevStatus) {
      case "building":
        status = "draft";
        break;

      case "draft":
        status = "published";
        break;

      case "published":
        status = "draft";
        break;

      default:
        // console.log("err parameter", prevStatus);
        break;
    } // OPEN MODAL


    if (status !== "") {
      setStatusTemplateToChange(status);
      setOpenHandleChangeStatusTemplate(!openHandleChangeStatusTemplate);
    } // CLOSE MODAL
    else {
        setOpenHandleChangeStatusTemplate(!openHandleChangeStatusTemplate);
        setStatusTemplateToChange(props.status);
      }
  }; // MODAL RESTART TEMPLATE


  var handleModalEditTemplate = function handleModalEditTemplate() {
    // console.log("handle edit template clicked");
    setOpenHandleEditTemplate(!openHandleEditTemplate);
  }; // MODAL DELETE TEMPLATE


  var handleModalDeleteTemplate = function handleModalDeleteTemplate() {
    // console.log("handle delete template clicked");
    setOpenHandleDeleteTemplate(!openHandleDeleteTemplate);
  };

  var handleChangeStatusLanguage = function handleChangeStatusLanguage(language, prevStatus) {
    var status = "";

    switch (prevStatus) {
      case "draft":
        status = "published";
        break;

      case "published":
        status = "draft";
        break;

      default:
        break;
    }

    if (status !== "") props.handleChangeStatusLanguage(language, status); // else console.log("error prevStatus", prevStatus);
  }; // FUNCTIONS TAB


  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var contentTabHandler = function contentTabHandler(tab) {
    var auxTab = "";
    props.languages && Object.keys(props.languages).forEach(function (language) {
      if (language === tab) {
        auxTab = language;
      }
    }); // tab is info

    if (auxTab === "") {
      return /*#__PURE__*/React.createElement(TemplatesTemplateInfo, {
        languages: props.languages,
        status: props.status,
        isBestPractice: props.isBestPractice,
        visible: props.visible,
        type: props.type,
        tags: props.tags,
        handleModalEditType: handleModalEditType // handleModalEditTags={handleModalEditTags}
        ,
        handleModalAddLanguage: handleModalAddLanguage,
        handleBestPracticeTemplate: handleBestPracticeTemplate,
        handleModalRestartTemplate: handleModalRestartTemplate,
        handleModalChangeStatusTemplate: handleModalChangeStatusTemplate,
        handleModalEditTemplate: handleModalEditTemplate,
        handleModalDeleteTemplate: handleModalDeleteTemplate
      });
    } //tab is language


    if (props.languages[auxTab].downloaded) {
      return /*#__PURE__*/React.createElement(TemplatesTemplateLanguage, {
        ref: childRef,
        language: props.languages[auxTab],
        tab: auxTab,
        handleSaveLanguage: props.handleSaveLanguage,
        handleReviewLanguage: props.handleReviewLanguage,
        handleModalDeleteLanguage: handleModalDeleteLanguage,
        handleModalEditLanguage: handleModalEditLanguage,
        handleChangeStatusLanguage: handleChangeStatusLanguage,
        handleDeleteItem: props.handleDeleteItem,
        handleAddItem: props.handleAddItem,
        handleEditItem: props.handleEditItem,
        handleSubmitEditTagsLanguage: props.handleSubmitEditTagsLanguage,
        handleDetailsEditorChangeLanguage: props.handleDetailsEditorChangeLanguage,
        handleDownloadTask: props.handleDownloadTask,
        idTemplate: props.idTemplate
      });
    } else {
      props.downloadLanguage(auxTab);
      return null;
    }
  }; // CONTROL WEB ALERT


  var shouldBlockNavigation = useRef();
  useEffect(function () {
    checkSavedLanguages();

    if (shouldBlockNavigation && alert) {
      window.onbeforeunload = function () {
        return true;
      };
    } else {
      window.onbeforeunload = undefined;
    }
  });

  var checkSavedLanguages = function checkSavedLanguages() {
    var checked = props.languages ? Object.keys(props.languages).find(function (language) {
      return props.languages[language].saved === false;
    }) : undefined;
    console.log("check language", checked);
    setAlert(checked === undefined ? false : true);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Prompt, {
    when: alert,
    message: "You have changes without save, do you want to continue?"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, alertS3), /*#__PURE__*/React.createElement(DialogTemplateEditType, {
    types: types,
    data: {
      type: props.type
    },
    open: openHandleEditType,
    onClose: handleModalEditType,
    onSubmit: props.handleSubmitEditType
  }), /*#__PURE__*/React.createElement(DialogTemplateAddLanguage, {
    open: openHandleAddLanguage,
    onClose: handleModalAddLanguage,
    languages: props.languages && Object.keys(props.languages).map(function (_key) {
      return _key;
    }),
    onSubmit: props.handlePreviousAddLanguage
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleDeleteLanguage,
    onClose: handleModalDeleteLanguage,
    title: "Do you want to remove this language?",
    text: "You will lose all content from this language",
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDeleteLanguage,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      setValue("es");
      handleModalDeleteLanguage();
      props.handleDeleteLanguage(languageToDelete);
    }
  }), /*#__PURE__*/React.createElement(DialogTemplateLanguageInfo, {
    open: openHandleEditLanguage,
    onClose: handleModalEditLanguage,
    data: languageToEdit && {
      name: props.languages[languageToEdit].name,
      description: props.languages[languageToEdit].description
    },
    onSubmit: function onSubmit(values) {
      return props.handleEditLanguage(values, languageToEdit);
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleChangeStatusTemplate,
    onClose: handleModalChangeStatusTemplate,
    title: "Confirm status template",
    text: "Do you want to change the status of this template to '" + statusTemplateToChange + "'?",
    submit: "Confirm",
    buttonColorSubmit: "primary",
    buttonVariantSubmit: "outlined",
    onCancel: handleModalChangeStatusTemplate,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalChangeStatusTemplate();
      props.handleChangeStatusTemplate(statusTemplateToChange);
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleRestartTemplate,
    onClose: handleModalRestartTemplate,
    title: "Do you want to restart this template?",
    text: "All languages but Spanish will be removed",
    submit: "Restart",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalRestartTemplate,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalRestartTemplate();
      props.handleRestartTemplate();
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleDeleteTemplate,
    onClose: handleModalDeleteTemplate,
    title: "Do you want to delete this template?",
    text: "You will lose all content from this template",
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDeleteTemplate,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalDeleteTemplate();
      props.handleDeleteTemplate();
    }
  })), props.languages && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Back to templates"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "primary",
    component: Link,
    to: "/templates"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    color: "primary"
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "scrollable" // className={classes.mb30}
    ,
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: [{
      label: "Info",
      value: "info"
    }].concat(_toConsumableArray(Object.keys(props.languages).map(function (language) {
      return arrLanguages.find(function (_language) {
        return _language.value === language;
      }) ? arrLanguages.find(function (_language) {
        return _language.value === language;
      }) : {
        label: "undefined" + language,
        value: language
      };
    })))
  })), value !== "info" && /*#__PURE__*/React.createElement(Grid, {
    xs: 2,
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(FileUpload, {
    variant: "text",
    translation: {
      buttons: {
        upload: /*#__PURE__*/React.createElement(PhotoLibraryIcon, {
          color: "primary"
        })
      }
    },
    s3path: "templates/",
    onUploadError: function onUploadError(values) {
      return handleAlertS3("error", values);
    },
    onUploadFinish: function onUploadFinish(values) {
      return handleAlertS3("success", values);
    },
    server: props.server,
    accept: "image/*",
    signingUrl: "s3/sign",
    title: "Upload image"
  }), props.status === "building" ? null : value === "info" ? null : /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Add new language"
  }, /*#__PURE__*/React.createElement(LibraryAddIcon, {
    style: {
      marginLeft: "16px",
      marginTop: "10px"
    },
    variant: "contained",
    color: "primary",
    onClick: handleModalAddLanguage
  })))), contentTabHandler(props.languages && value));
});
export { TemplatesTemplateSingle };